import { getPadding } from "../viewportHelpers";

export async function autoFocus() {
    var [dataPerChannel, imageScale] = await getFullImagePixels.call(this);
    const numOfPixels = dataPerChannel.r.length;

    var grayscaleData = [];
    for (let i = 0; i < numOfPixels; i++) {
        grayscaleData[i] = Math.floor(0.299 * dataPerChannel.r[i] + 0.587 * dataPerChannel.g[i] + 0.114 * dataPerChannel.b[i]);
    }

    const histogram = getHistogram(grayscaleData);
    const valuesPercentage = [];

    for (let i = 0; i < histogram.length; i++) {
        valuesPercentage.push(histogram[i] / numOfPixels * 100);
    }

    const percThreshhold = 0.01;
    const start = valuesPercentage.findIndex(p => p >= percThreshhold);
    const end = histogram.findIndex(p => p === Math.max(...histogram));
    const scale = 255.0 / (end - start);

    const channels = ['r', 'g', 'b'];
    const transformedChannels = {};

    for (let channel of channels) {
        transformedChannels[channel] = [];
        for (let i = 0; i < numOfPixels; i++) {
            let transformedPixel = Math.max(Math.min(Math.round((dataPerChannel[channel][i] - start) * scale), 255), 0);
            transformedChannels[channel].push(transformedPixel);
        }
    }

    var transGrayscaleData = [];
    for (let i = 0; i < numOfPixels; i++) {
        transGrayscaleData[i] = Math.floor(0.299 * transformedChannels.r[i] + 0.587 * transformedChannels.g[i] + 0.114 * transformedChannels.b[i]);
    }

    const imageWidth = Math.round(this.imageInfo.Width * imageScale);
    var binaryValues1D = [];
    var binaryImage2D = [];

    for (let i = 0; i < numOfPixels; i++) {
        let binarizedPixel = (transGrayscaleData[i] <= 230) ? 255 : 0;
        binaryValues1D.push(binarizedPixel);
    }

    while (binaryValues1D.length > 0) {
        binaryImage2D.push(binaryValues1D.splice(0, imageWidth));
    }

    const boundingBox = calculateBoundingBox.call(this, binaryImage2D, imageScale);
    this.fitToExtent(boundingBox, false);
}

const loadImage = (imageUrl) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.crossOrigin = 'Anonymous';
        img.src = imageUrl;
    });
};

async function getFullImagePixels() {
    const sessionId = this.sessionID;
    const activeLayer = this.getActiveLayer();
    const activeTimeFrame = this.getActiveTimeFrame();
    const scale = 1000.0 / Math.max(this.imageInfo.Width, this.imageInfo.Height);
    const url = `${this.serverUrls[0]}/region?pathOrUid=${encodeURIComponent(this.imageInfo.Filename)}&format=jpg&timeframe=${activeTimeFrame}&layer=${activeLayer}&sessionID=${encodeURIComponent(sessionId)}&x=0&y=0&width=${this.imageInfo.Width}&height=${this.imageInfo.Height}&scale=${scale}`;
    const image = await loadImage(url);

    const pixels = getImageData(image);
    const pixelsPerChannel = getChannels(pixels);

    return [pixelsPerChannel, scale];
}

const getImageData = (img) => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const context = canvas.getContext('2d');
    context.drawImage(img, 0, 0);
    const { data } = context.getImageData(0, 0, img.width, img.height);

    return data;
};

const getChannels = (data) => {
    const r = [];
    const g = [];
    const b = [];
    const a = [];
    for (let i = 0; i < data.length;) {
        r.push(data[i++]);
        g.push(data[i++]);
        b.push(data[i++]);
        a.push(data[i++]);
    }

    return {
        r, g, b, a,
    };
};

const getHistogram = (channel, L = 256) => {
    const result = new Array(L).fill(0);
    for (const value of channel) {
        result[value]++;
    }

    return result;
};

function calculateBoundingBox(binaryImage, imageScale) {
    const padding = getPadding.call(this);
    let minX = binaryImage.length;
    let maxX = 0;
    let minY = binaryImage[0].length;
    let maxY = 0;

    for (let row = 0; row < binaryImage.length; row++) {
        for (let col = 0; col < binaryImage[row].length; col++) {
            if (binaryImage[row][col] === 255) {
                minX = Math.min(minX, col);
                maxX = Math.max(maxX, col);

                minY = Math.min(minY, row);
                maxY = Math.max(maxY, row);
            }
        }
    }

    minX /= imageScale;
    minY /= imageScale;
    maxX /= imageScale;
    maxY /= imageScale;

    return [minX + padding.xPadding, minY + padding.yPadding, maxX + padding.xPadding, maxY + padding.yPadding];
}

export function clearAutoAdjust() {
    if (!this.autoAdjustTileTransformer) {
        return;
    }
    const self = this;
    var newTransformersList = this.getTileTransformers().filter(x => { x !== self.autoAdjustTileTransformer });
    this.setTileTransformers(newTransformersList);
    this.autoAdjustTileTransformer = null;
    this.redraw();
}